<template>
  <div class="app-container post-list">
    <div class="post-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="post-list-filter-value" @keyup.enter.native="searchChange" v-model.trim="search.keywords" placeholder="内容标题/内容正文" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="post-list-filter-value" @keyup.enter.native="searchChange" v-model.trim="search.postedByName" placeholder="发布者" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="post-list-filter-value" placeholder="分类" v-model="search.parentTagId" clearable size="small">
              <el-option
                v-for="item in search.parentTagOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="post-list-filter-value" placeholder="话题" v-model="search.tagId" clearable size="small">
              <template v-if="getRelatedTags(search.parentTagId)">
                <el-option
                  v-for="item in search.tagOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </template>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
      <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-date-picker
              class="post-list-filter-date"
              v-model="search.searchTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small">
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="post-list-filter-value" placeholder="内容类别" v-model="search.postType" clearable size="small">
              <el-option
                v-for="item in postTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <!-- <div class="grid-content bg-purple">
            <el-select class="post-list-filter-value" placeholder="是否后台发布" v-model="search.isAdminPost" clearable size="small">
              <el-option
                v-for="item in adminPostOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div> -->
        </el-col>
        <el-col :span="6">
          <div>
            <el-button class="post-list-filter-reset" size="medium" @click="searchChange">立即筛选</el-button>
            <el-button class="post-list-filter-search" size="medium" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <basic-container class = "post-list-container">
      <avue-crud ref="crud"
                 :option="postTableOption"
                 :data="tableData"
                 :page="page"
                 :table-loading="tableLoading"
                 :before-open="handleOpenBefore"
                 @current-change="handleCurrentChange"
                 @size-change="handleSizeChange"
                 @sort-change="handleSortChange">

        <template slot="title"
                  slot-scope="scope">
          <div class="title">
            <div class="post-cover-image" v-if="scope.row.coverImg">
              <img :src="scope.row.coverImg | ossImageProcess" v-viewer>
            </div>
            <a href="javascript:void(0);" @click="handleView(scope.row,scope.index);"
                class="post-list-container-button">
              {{scope.row.title}}
            </a>
          </div>
        </template>
        <template slot="menuLeft">
          <el-button type="primary" @click="handleAdd" icon="el-icon-plus" size="small" v-if="permissions.content_material_add">新增素材</el-button>
        </template>
        <template slot="parentTags"
                  slot-scope="scope">
              {{scope.row.parentTags}}
        </template>
        <template slot="tags"
                  slot-scope="scope">
              {{scope.row.tags}}
        </template>
        <template slot="link"
                  slot-scope="scope">
          <div class="link">
            <a @click.stop.prevent="copyText(scope.row.link)" href="#">复制</a> {{scope.row.link}}
          </div>

        </template>
        <template slot="menu"
                  slot-scope="scope" width=100>
          <el-button size="mini"
                v-if="permissions.content_material_edit && scope.row.canEdit"
                type="text"
                icon="icon-edit"
                title="编辑"
                @click="handlePostUpdate(scope.row,scope.index)">
          </el-button>
          <el-button size="mini"
                type="text"
                icon="icon-upload-shelf"
                title="上架"
                v-if="permissions.content_material_up && scope.row.isBanned"
                @click="handleUp(scope.row,scope.index)">
          </el-button>
          <el-button size="mini"
                type="text"
                icon="icon-download-shelf"
                title="下架"
                v-if="permissions.content_material_down && !scope.row.isBanned"
                @click="handleDown(scope.row,scope.index)">
          </el-button>
          <el-button type="text"
            v-if="permissions.content_material_delete && scope.row.canEdit"
            icon="icon-delete"
            size="mini"
            title="删除"
            @click="handleDelete(scope.row,scope.index)"></el-button>
        </template>

      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
  import {fetchPostList, updatePostBanStatus, removePost} from '@/api/post/post'
  import {getTagsByType, searchRelatedTag} from '@/api/basic/tagtype'
  import {listTableOption} from '@/const/crud/material/content-meterial'
  import circleEnum from '@/common/enums/defaultCircle';
  import {mapGetters} from "vuex";

  export default {
    name: "table_post",
    data() {
      return {
        adminPostOptions: [
          { label: '是', value: 1 },
          { label: '否', value: 0 },
        ],
        postTypeOptions: [
          { label: '图文', value: 0 },
          { label: '视频', value: 1 },
        ],
        search: {
          current: 1,
          size: 10,
          postedByName: "",
          searchTime: [],
          sortField: "",
          sortPolicy: "",
          expired: "",
          postType: "",
          tag: "",
          keywords: "",
          parentTagId: "",
          tagId: "",
          parentTagOptions: [],
          tagOptions: [],
          preParentTagId: "",
          isAdminPost: ""
        },

        // 列表页面
        tableData:[],
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 10, // 每页显示多少条,
        },
        tableLoading: false,
        postTableOption: listTableOption,
        circleId: circleEnum.HTML_MATERIAL.circleId, // 素材
      };
    },
    async created() {
      await this.getRelatedTagOptionse();
      this.queryPosts();
    },
    computed: {
      ...mapGetters(['permissions']),
      startTime: function () {
        if (this.search.searchTime && this.search.searchTime.length > 0) {
          return this.search.searchTime[0]
        } else {
          return null
        }
      },
      endTime: function () {
        if (this.search.searchTime && this.search.searchTime.length > 1) {
          return this.search.searchTime[1]
        } else {
          return null
        }
      }
    },
    methods: {
      copyText(text) {
        this.$copyText(text).then(
          res => {
            this.$message({
              showClose: true,
              type: 'success',
              message: '已成功复制'
            })
          },
          err => {
            this.$message({
              showClose: true,
              type: 'error',
              message: '失败'
            })
          }
		    )
      },
      formatData(records) {
        // 帖子列表格式化
        let _this = this
        if (records && records.length > 0) {
          records.forEach(function(record, index) {
            if (record.postedBy) {
              record.postedByName = record.postedBy.name
              record.canEdit = record.postedBy.memberType == 1;
              if (record.postedByName == "") {
                record.postedByName = "--"
              }
            } else {
              record.postedByName = "--"
            }

            if (!record.commentCount) {
              record.commentCount = 0
            }
            if (!record.favoriteCount) {
              record.favoriteCount = 0
            }
            if (!record.likeCount) {
              record.likeCount = 0
            }
            if (!record.viewedCount) {
              record.viewedCount = 0
            }

            if (record.finalHeatValue) {
              record.finalHeatValue = parseInt(record.finalHeatValue.toFixed(0))
            } else {
              record.finalHeatValue = 0;
            }
            record.isNotBanned = record.isBanned ? '是' : '否';
            record.postType = record.postType == 0 ? '图文' : '视频';
            record.tags = record.postTags.map(item => {return item.tagName}).join('、');
            record.parentTags = record.postTags.map(item => {return item.parentTagName}).join('、');
            record.link = `/material/content/${record.id}`;
          })
        }

        return records
      },
      getParameter(param){
        // 提取url参数值
        let url = location.href
        let reg = new RegExp("(^|&)" + param + "=([^&]*)(&|$)")
        let r = url.substr(url.indexOf("\?") + 1).match(reg)
        if (r != null) return unescape(r[2])
        else return null
      },
      getList() {
        // 获取帖子列表
        let params = {
          circleId: this.circleId,
          current: this.search.current,
          size: this.search.size
        }
        // 增加搜索功能
        if (this.search.keywords != "" && this.search.keywords.trim() != "")
          params.keywords = this.search.keywords
        if (this.search.postedByName != "" && this.search.postedByName.trim() != "")
          params.postedByName = this.search.postedByName
        if (this.search.postType !== null && this.search.postType !== "")
          params.postType = this.search.postType
        if (this.search.tagId !== null && this.search.tagId !== "")
          params.tagId = this.search.tagId
        if (this.search.parentTagId !== null && this.search.parentTagId !== "" && !this.search.tagId) {
          params.parentTagId = this.search.parentTagId
        }
        if (this.search.isAdminPost !== null && this.search.isAdminPost !== "")
          params.memberType = this.search.isAdminPost ? 1 : 0;

        if (this.startTime && this.endTime) {
          params.postStartTime = this.startTime
          let t = new Date(this.endTime)
          t.setDate(t.getDate() + 1)
          params.postEndTime = t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate()
        } else {
          params.postStartTime = null
          params.postEndTime = null
        }

        // 增加排序功能
        if (this.search.sortField != "" && this.search.sortField.trim() != "")
          params.sortField = this.search.sortField
        else
          params.sortField = "post_time"
        if (this.search.sortPolicy != "" && this.search.sortPolicy.trim() != "")
          params.sortPolicy = this.search.sortPolicy
        else
          params.sortPolicy = "desc"

        this.tableLoading = true
        fetchPostList(params).then(response => {
          this.tableData = this.formatData(response.data.data.records)
          this.page.total = response.data.data.total
          this.tableLoading = false
        })
      },
      initPage() {
        this.page.currentPage = 1
        this.page.pageSize = this.search.size
        this.search.current = 1
        this.search.sortField = ""
        this.search.sortPolicy = ""
      },
      async getRelatedTagOptionse() {
        const response = await getTagsByType({type: 2});
        if (Array.isArray(response.data.data)) {
          this.search.parentTagOptions = response.data.data.map(x => {
            return {
              value: x.id,
              label: x.name
            }
          })
        }
      },
      searchChange() {
        this.initPage()
        this.getList()
      },
      searchReset() {
        this.search.keywords = "";
        this.search.postedByName = ""
        this.search.searchTime = []
        this.search.isAdminPost = ""
        this.search.tagId = "";
        this.search.parentTagId = "";
        this.search.postedByName = "";
        this.search.postType = "";
        this.searchChange()
      },
      toMemberDetail(postedById) {
        // 帖子详情里点击发布者姓名，链接转到该发布者的会员详情
        this.$router.push({
          path: "/upms/member/detail/" + postedById,
        })
      },
      toCircleDetail(circleId) {
        // 帖子详情里点击圈子名称，链接转到该圈子的详情页面
        this.$router.push({
          path: "/post/circle/detail/" + circleId,
        })
      },
      toCommentList(curPostId) {
        // 帖子详情里点击评论数，链接转到该帖子的评论列表
        this.$router.push({
          path: "/post/comment",
          query: {
            postId: curPostId
          }
        })
      },
      handleCurrentChange(val) {
        this.page.currentPage = val
        this.search.current = val
        this.getList()
      },
      handleSizeChange(val) {
        this.page.pageSize = val
        this.search.size = val
        this.getList()
      },
      handleSortChange(val) {
        // 检查排序对象
        if (val.prop == "commentCount") {
          this.search.sortField = "comment_count"
        } else if (val.prop == "favoriteCount") {
          this.search.sortField = "favorite_count"
        } else if (val.prop == "likeCount") {
          this.search.sortField = "like_count"
        } else if (val.prop == "viewedCount") {
          this.search.sortField = "viewed_count"
        } else if (val.prop == "postTime"){
          this.search.sortField = "post_time"
        } else if (val.prop == "finalHeatValue"){
          this.search.sortField = "final_heat_value"
        } else {
          this.search.sortField = ""
        }
        // 检查排序方式
        if (val.order == 'ascending') {
          this.search.sortPolicy = "asc"
        } else if (val.order == 'descending') {
          this.search.sortPolicy = "desc"
        } else {
          this.search.sortPolicy = ""
        }
        this.getList()
      },
      handleAdd() {
        this.$router.push({path: `/content/list/add?circleId=${circleEnum.HTML_MATERIAL.circleId}`})
      },
      handleView(row, index) {
        if (row.id){
          this.$router.push({
            path: `/content/list/detail/${row.id}`
          })
        } else {
          this.$message({
            showClose: true,
            message: '该帖子不存在',
            type: 'warning'
          })
        }
      },
      getPostDTO(row, inputIsBanned){
        let postDTO= {
          id: row.id,
          isBanned: inputIsBanned,
        }
        return postDTO
      },
      handleUp(row, index) {
        // 上架功能
        let postDTO = this.getPostDTO(row, 0)
        let _this = this
        this.$confirm('是否确认上架该标题为"' + row.title + '"'+ '的帖子?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          return updatePostBanStatus(postDTO);
        }).then(() => {
          this.getList()
          _this.$message({
            showClose: true,
            message: '上架成功',
            type: 'success'
          })
        }).catch(function () {
        })
      },
      handleDown(row, index) {
        // 下架功能
        let postDTO = this.getPostDTO(row, 1)
        let _this = this
        this.$prompt('下架原因', '下架', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern:/^.*[^\s]+.*$/,
          inputErrorMessage: '不能为空'
        }).then(banCommentValue => {
          postDTO.banComment = banCommentValue.value
          return updatePostBanStatus(postDTO);
        }).then(response=>{
          this.getList()
          _this.$message({
            showClose: true,
            type: 'success',
            message: '下架成功'
            })
          }).catch(function () {
        })
      },
      handleOpenBefore(show, type) {
        show();
      },
      handleDelete(row) {
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          removePost(row.id).then(response => {
            if (response.data.data) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.getList()
            }
          }).catch(error => {
            console.error(error)
            this.$message({
              message: '删除失败',
              type: 'error'
            })
          })
        })
      },
      handlePostUpdate(row) {
        this.$router.push({path: '/content/list/edit', query: {id: row.id, circleId: circleEnum.HTML_MATERIAL.circleId}})
      },
      queryPosts() {
        if (this.$route.query.date !== undefined) {
          this.search.searchTime.push(this.$route.query.date, this.$route.query.date)
        }
        this.getList()
      },
      // 获取与帖子类别相关的主题
      async getRelatedTags(tagId) {
        let _this = this
        if (! tagId) return false
        if (_this.search.preParentTagId == tagId) return true
        _this.search.tagId = "";
        _this.search.preParentTagId = tagId;
        const response = await searchRelatedTag(tagId);
        if (Array.isArray(response.data.data.records)) {
          _this.search.tagOptions = response.data.data.records.map(x => {
            return {
              value: x.id,
              label: x.name
            }
          })
        }
      },
    }
  };

</script>


<style lang="scss" scoped>

.post-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }
    &-value {
      width: 96% !important;
    }
    &-date {
      width: 96% !important;
    }
    &-search {
      float: right;
      margin-right: 8px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
    }
  }
}
/deep/.el-dialog__body {
  padding : 10px 20px 40px 20px;
}
/deep/.el-input-number {
  line-height: 36px;
}

.title {
  display: flex;
  align-items: center;
  .post-cover-image {
    display: flex;
    width: fit-content;
    margin-right: 12px;
    img {
      width: 40px;
      height: 40px;
      object-fit: cover;
      max-width: 100%;
    }
  }
}

.link {
  a {
    color: #5383F3;
    padding-right: 8px;
  }
}

.post-top-dialog {
  height: 90px;
  &-item {
    display: flex;
    flex-direction: row;
    justify-content: center;
    &-label {
      font-size: 15px;
      color: #606266;
      padding: 10px;
    }
    &-content {
      width: 200px !important;
    }
    &-tip {
      font-size: 12px;
      color: #999999;
      margin-bottom: 10px;
      margin-top: 6px;
    }
    &-value {
      width: 200px;
    }
  }
}
.manual-input-label{
    font-size: 15px;
    color: #606266;
    padding: 10px;
}

</style>
